import { FirestoreDataConverter, Timestamp } from '@angular/fire/firestore';

/**
 * Daily synchronized capacity of a planning resource
 */
export class PlanningCapacity {
  id: string;
  organizationId: string;
  department: number;
  machineId: number;
  machineName: string;
  installationResourceId: string;
  date: string;
  capacityHours: number;
  startTime: number;
  endTime: number;
  planningStart: Date | null;
  planningEnd: Date | null;
  source: 'weekly' | 'exception';
  updatedAt: Date | null;

  constructor(capacity?: Partial<PlanningCapacity>) {
    this.id = capacity?.id ?? '';
    this.organizationId = capacity?.organizationId ?? '';
    this.department = capacity?.department ?? 0;
    this.machineId = capacity?.machineId ?? 0;
    this.machineName = capacity?.machineName ?? '';
    this.installationResourceId = capacity?.installationResourceId ?? '';
    this.date = capacity?.date ?? '';
    this.capacityHours = capacity?.capacityHours ?? 0;
    this.startTime = capacity?.startTime ?? 0;
    this.endTime = capacity?.endTime ?? 0;
    this.planningStart = capacity?.planningStart ?? null;
    this.planningEnd = capacity?.planningEnd ?? null;
    this.source = capacity?.source ?? 'weekly';
    this.updatedAt = capacity?.updatedAt ?? null;
  }

  /**
   * Converter used to convert object from firebase
   */
  static converter: FirestoreDataConverter<PlanningCapacity> = {
    toFirestore: (capacity: PlanningCapacity) => ({
      organizationId: capacity.organizationId,
      department: capacity.department,
      machineId: capacity.machineId,
      machineName: capacity.machineName,
      installationResourceId: capacity.installationResourceId,
      date: capacity.date,
      capacityHours: capacity.capacityHours,
      startTime: capacity.startTime,
      endTime: capacity.endTime,
      planningStart: capacity.planningStart,
      planningEnd: capacity.planningEnd,
      source: capacity.source,
      updatedAt: capacity.updatedAt,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new PlanningCapacity({
        ...data,
        id: snapshot.id,
        planningStart: (data['planningStart'] as Timestamp)?.toDate() ?? null,
        planningEnd: (data['planningEnd'] as Timestamp)?.toDate() ?? null,
        updatedAt: (data['updatedAt'] as Timestamp)?.toDate() ?? null,
      });
    }
  };
}
